import requiredFieldConfigRaw from '../../data/requiredFieldConfig';
import SubmitLoanPageRenderer from './SubmitLoanPageRenderer';

const SubmitLoan = () => {
    const config = requiredFieldConfigRaw.Pages.find(
        (p) => p.Page === 'Submit Loan'
    );
    return (
        <SubmitLoanPageRenderer
            pageName="Submit Loan"
            config={config}
            redirectPage="Submit Loan"
        />
    );
};

export default SubmitLoan;